import React from "react";
import styled from "@emotion/styled";
import { Text } from "styles/utility-components";

import SubscriptionAddonCard, { SubscriptionAddonCardProps } from "./SubscriptionAddonCard";

const addonCards: SubscriptionAddonCardProps[] = [
  {
    dataType: "STRATEGY",
    icon: "strategyPart",
    title: "Create Strategy",
    description:
      "Size and sort your market—break it down by territories, accounts, and frameworks to build a sharper go-to-market strategy.",
    oldPrice: "400",
    newPrice: "100",
  },
  {
    dataType: "BIDS",
    icon: "bidPart",
    title: "Bid Studio",
    description:
      "Streamline your bid process—leverage AI-driven qualification, buyer insights, and collaborative tools to focus on winning, not admin.",
    oldPrice: "625",
    newPrice: "150",
  },
];

export default function SubscriptionAddons() {
  return (
    <Container>
      <Text h1>Our add-ons</Text>
      <Text>Available as add-ons for our Growth or Expert plans</Text>
      <CardsContainer>
        {addonCards.map((card, i) => (
          <SubscriptionAddonCard key={i} {...card} />
        ))}
      </CardsContainer>
    </Container>
  );
}

const Container = styled.div({
  marginTop: 80,
});

const CardsContainer = styled.div({
  marginTop: 24,
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 24,
});
